import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { trackByIndex } from '@y42/angular/util';
import { ColumnTypeEnum, OperatorEnum } from '@y42/json-schema';
import { SelectOption } from '@y42/util/select-option';
import { OperationInputFormService } from '../../operation-input-form.service';

@UntilDestroy()
@Component({
  selector: 'y42-operation-input-number',
  templateUrl: './operation-input-number.component.html',
  styleUrls: ['../operation-input-shared.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OperationInputNumberComponent {
  constructor(private readonly formService: OperationInputFormService) {}

  readonly trackByIndex = trackByIndex<unknown>;

  @Input() columnType!: ColumnTypeEnum;
  @Input() enableMoreConditions = true;
  @Input() operatorOptions?: Array<SelectOption<OperatorEnum>>;

  readonly OperatorEnum = OperatorEnum;
  readonly operationsFormArray = this.formService.operationsFormArray;
}
